import React, { useState } from "react"
import { FaTimes } from "react-icons/fa"

import { setStockTransferRequestAsViewed } from "services"
import { Modal, TextField } from "components"
import StrrtrmTableRow from "./StrrtrmTableRow"
import StrrtrmFooter from "./StrrtrmFooter"
import classes from "./index.module.scss"

const StrRespondToRequestModal = (props) => {
  const {
    stockTransferRequest,
    setStockTransferRequests,
    showStockTransferRespondeModal,
    setShowStockTransferRespondeModal
  } = props

  const [acceptedItems, setAcceptedItems] = useState([])
  const [responseMessage, setResponseMessage] = useState("")

  const handleExited = () => {
    setAcceptedItems([])

    setResponseMessage("")
  }

  const fillForm = () => {
    const acceptedItems =
      stockTransferRequest.stockTransferStatus === "pending"
        ?
        stockTransferRequest.requestedItems.map(requestedItem => ({
          foodId: requestedItem.foodId,
          optionId: requestedItem.optionId,
          foodImageCover: requestedItem.foodImageCover,
          foodName: requestedItem.foodName,
          foodOptionName: requestedItem.foodOptionName,
          isSimple: requestedItem.isSimple,
          unit: requestedItem.unit,
          requestedQuantity: requestedItem.requestedQuantity,
          acceptedQuantity: String(requestedItem.requestedQuantity)
        }))
        :
        stockTransferRequest.requestedItems.map(requestedItem => ({
          foodId: requestedItem.foodId,
          optionId: requestedItem.optionId,
          foodImageCover: requestedItem.foodImageCover,
          foodName: requestedItem.foodName,
          foodOptionName: requestedItem.foodOptionName,
          isSimple: requestedItem.isSimple,
          unit: requestedItem.unit,
          requestedQuantity: requestedItem.requestedQuantity,
          acceptedQuantity: String(requestedItem.acceptedQuantity)
        }))

    setAcceptedItems(acceptedItems)

    setResponseMessage(
      stockTransferRequest.responseMessage
    )
  }

  const setRequestAsViewed = () => {
    if (stockTransferRequest.isViewed) return

    setStockTransferRequestAsViewed(
      stockTransferRequest._id
    )

    setStockTransferRequests(prev =>
      prev.map(str =>
        str._id === stockTransferRequest._id
          ? { ...str, isViewed: true }
          : str
      )
    )
  }

  const handleEnter = () => {
    setRequestAsViewed()

    fillForm()
  }

  return (
    <Modal
      
      size="lg"
      backdrop="static"
      onEnter={handleEnter}
      onExited={handleExited}
      show={showStockTransferRespondeModal}
      onHide={() => setShowStockTransferRespondeModal(false)}
    >
      <div className={classes["container"]}>
        <div className={classes["header"]}>
          <button onClick={() => setShowStockTransferRespondeModal(false)}>
            <FaTimes />
          </button>
        </div>

        <div className={classes["title"]}>
          جزئیات درخواست
        </div>

        <div className={classes["table-container"]}>
          <table className={classes["table"]}>
            <thead>
              <tr>
                <th> </th>
                <th style={{ width: "60%" }}>
                  نام کالا
                </th>
                <th style={{ textAlign: "center" }}>
                  مقدار درخواستی
                </th>
                <th style={{ textAlign: "center", width: "20%" }}>
                  مقدار قبول شده
                </th>
              </tr>
            </thead>
            <tbody>
              {acceptedItems.map(acceptedItem =>
                <StrrtrmTableRow
                  key={acceptedItem.optionId}
                  acceptedItem={acceptedItem}
                  setAcceptedItems={setAcceptedItems}
                />
              )}
            </tbody>
          </table >
        </div>

        <div className={classes["message"]}>
          <TextField
            componentClass="textarea"
            rows={4}
            label="پاسخ به درخواست"
            maxLength={600}
            value={responseMessage}
            onChange={(e) => setResponseMessage(e.target.value)}
          />
        </div>

        <StrrtrmFooter
          responseMessage={responseMessage}
          acceptedItems={acceptedItems}
          stockTransferRequest={stockTransferRequest}
          setStockTransferRequests={setStockTransferRequests}
          setShowStockTransferRespondeModal={setShowStockTransferRespondeModal}
        />
      </div>
    </Modal>
  )
}

export default StrRespondToRequestModal